{
  "role": "http://xbrl.ssm.com.my/role/ssm/rol_ssmt-fs-mfrs_2022-12-31/ssmt-fs-mfrs_2022-12-31_role-320000",
  "sheetId": "StatementOfProfitOrLossByNature",
  "label": "[320000] Statement of profit or loss using classification by nature of expense method (MFRS)",
  "description": "Statement of profit or loss using classification by nature of expense method",
  "controls": [
    {
      "qname": "ssmt:StatementOfProfitOrLossByNatureHeader",
      "label": "STATEMENT OF PROFIT OR LOSS (BY NATURE)",
      "type": "SectionHeader",
      "ui": {
        "control": "header",
        "level": 1
      }
    },
    {
      "qname": "ssmt:RevenueAndIncomeHeader",
      "label": "REVENUE AND INCOME",
      "type": "SectionHeader",
      "ui": {
        "control": "header",
        "level": 2
      }
    },
    {
      "qname": "ifrs-full:RevenueByNature",
      "label": "Revenue",
      "type": "MonetaryItemType",
      "ui": {
        "decimalPlaces": 0,
        "control": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-full:OtherIncomeByNature",
      "label": "Other income",
      "type": "MonetaryItemType",
      "ui": {
        "decimalPlaces": 0,
        "control": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt:ExpensesByNatureHeader",
      "label": "EXPENSES BY NATURE",
      "type": "SectionHeader",
      "ui": {
        "control": "header",
        "level": 2
      }
    },
    {
      "qname": "ifrs-full:ChangesInInventoriesOfFinishedGoodsAndWorkInProgressByNature",
      "label": "Changes in inventories of finished goods and work in progress",
      "type": "MonetaryItemType",
      "ui": {
        "decimalPlaces": 0,
        "control": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-full:RawMaterialsAndConsumablesUsedByNature",
      "label": "Raw materials and consumables used",
      "type": "MonetaryItemType",
      "ui": {
        "decimalPlaces": 0,
        "control": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true,
        "note": "Enter as negative value or system will treat as expense"
      }
    },
    {
      "qname": "ifrs-full:EmployeeBenefitsExpenseByNature",
      "label": "Employee benefits expense",
      "type": "MonetaryItemType",
      "ui": {
        "decimalPlaces": 0,
        "control": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true,
        "note": "Enter as negative value or system will treat as expense"
      }
    },
    {
      "qname": "ifrs-full:DepreciationAndAmortisationExpenseByNature",
      "label": "Depreciation and amortisation expense",
      "type": "MonetaryItemType",
      "ui": {
        "decimalPlaces": 0,
        "control": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true,
        "note": "Enter as negative value or system will treat as expense"
      }
    },
    {
      "qname": "ifrs-full:ImpairmentLossRecognisedInProfitOrLoss",
      "label": "Impairment loss recognised in profit or loss",
      "type": "MonetaryItemType",
      "ui": {
        "decimalPlaces": 0,
        "control": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true,
        "note": "Enter as negative value or system will treat as expense"
      }
    },
    {
      "qname": "ifrs-full:TransportationExpense",
      "label": "Transportation expense",
      "type": "MonetaryItemType",
      "ui": {
        "decimalPlaces": 0,
        "control": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true,
        "note": "Enter as negative value or system will treat as expense"
      }
    },
    {
      "qname": "ifrs-full:AdvertisingAndMarketingExpense",
      "label": "Advertising and marketing expense",
      "type": "MonetaryItemType",
      "ui": {
        "decimalPlaces": 0,
        "control": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true,
        "note": "Enter as negative value or system will treat as expense"
      }
    },
    {
      "qname": "ifrs-full:RentalExpenseByNature",
      "label": "Rental expense",
      "type": "MonetaryItemType",
      "ui": {
        "decimalPlaces": 0,
        "control": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true,
        "note": "Enter as negative value or system will treat as expense"
      }
    },
    {
      "qname": "ifrs-full:UtilitiesExpenseByNature",
      "label": "Utilities expense",
      "type": "MonetaryItemType",
      "ui": {
        "decimalPlaces": 0,
        "control": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true,
        "note": "Enter as negative value or system will treat as expense"
      }
    },
    {
      "qname": "ifrs-full:ProfessionalFeesExpense",
      "label": "Professional fees expense",
      "type": "MonetaryItemType",
      "ui": {
        "decimalPlaces": 0,
        "control": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true,
        "note": "Enter as negative value or system will treat as expense"
      }
    },
    {
      "qname": "ifrs-full:InsuranceExpenseByNature",
      "label": "Insurance expense",
      "type": "MonetaryItemType",
      "ui": {
        "decimalPlaces": 0,
        "control": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true,
        "note": "Enter as negative value or system will treat as expense"
      }
    },
    {
      "qname": "ifrs-full:ForeignExchangeLossByNature",
      "label": "Foreign exchange loss",
      "type": "MonetaryItemType",
      "ui": {
        "decimalPlaces": 0,
        "control": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true,
        "note": "Enter as negative value or system will treat as expense"
      }
    },
    {
      "qname": "ifrs-full:OtherExpensesByNature",
      "label": "Other expenses",
      "type": "MonetaryItemType",
      "ui": {
        "decimalPlaces": 0,
        "control": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true,
        "note": "Enter as negative value or system will treat as expense"
      }
    },
    {
      "qname": "ifrs-full:ProfitFromOperationsByNature",
      "label": "PROFIT FROM OPERATIONS",
      "type": "MonetaryItemType",
      "ui": {
        "decimalPlaces": 0,
        "control": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true,
        "calculated": true,
        "readonly": true,
        "calculation": "Revenue + OtherIncome - All Expenses"
      }
    },
    {
      "qname": "ssmt:FinanceItemsHeader",
      "label": "FINANCE AND ASSOCIATES/JOINT VENTURES",
      "type": "SectionHeader",
      "ui": {
        "control": "header",
        "level": 2
      }
    },
    {
      "qname": "ifrs-full:FinanceCostsByNature",
      "label": "Finance costs",
      "type": "MonetaryItemType",
      "ui": {
        "decimalPlaces": 0,
        "control": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true,
        "note": "Enter as negative value or system will treat as expense"
      }
    },
    {
      "qname": "ifrs-full:FinanceIncomeByNature",
      "label": "Finance income",
      "type": "MonetaryItemType",
      "ui": {
        "decimalPlaces": 0,
        "control": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-full:ShareOfProfitOfAssociatesByNature",
      "label": "Share of profit of associates",
      "type": "MonetaryItemType",
      "ui": {
        "decimalPlaces": 0,
        "control": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-full:ShareOfProfitOfJointVenturesByNature",
      "label": "Share of profit of joint ventures",
      "type": "MonetaryItemType",
      "ui": {
        "decimalPlaces": 0,
        "control": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-full:ProfitBeforeTaxByNature",
      "label": "PROFIT BEFORE TAX",
      "type": "MonetaryItemType",
      "ui": {
        "decimalPlaces": 0,
        "control": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true,
        "calculated": true,
        "readonly": true,
        "calculation": "ProfitFromOperations + FinanceIncome - FinanceCosts + ShareOfAssociates + ShareOfJVs"
      }
    },
    {
      "qname": "ssmt:TaxationByNatureHeader",
      "label": "TAXATION",
      "type": "SectionHeader",
      "ui": {
        "control": "header",
        "level": 2
      }
    },
    {
      "qname": "ifrs-full:IncomeTaxExpenseByNature",
      "label": "Income tax expense",
      "type": "MonetaryItemType",
      "ui": {
        "decimalPlaces": 0,
        "control": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true,
        "note": "Enter as negative value or system will treat as expense"
      }
    },
    {
      "qname": "ifrs-full:ProfitForTheYearByNature",
      "label": "PROFIT FOR THE YEAR",
      "type": "MonetaryItemType",
      "ui": {
        "decimalPlaces": 0,
        "control": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true,
        "calculated": true,
        "readonly": true,
        "calculation": "ProfitBeforeTax - IncomeTaxExpense"
      }
    },
    {
      "qname": "ssmt:AttributionByNatureHeader",
      "label": "PROFIT ATTRIBUTABLE TO:",
      "type": "SectionHeader",
      "ui": {
        "control": "header",
        "level": 2
      }
    },
    {
      "qname": "ifrs-full:ProfitAttributableToOwnersOfParentByNature",
      "label": "Owners of the parent",
      "type": "MonetaryItemType",
      "ui": {
        "decimalPlaces": 0,
        "control": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-full:ProfitAttributableToNonControllingInterestsByNature",
      "label": "Non-controlling interests",
      "type": "MonetaryItemType",
      "ui": {
        "decimalPlaces": 0,
        "control": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-full:TotalProfitAttributionByNature",
      "label": "Total",
      "type": "MonetaryItemType",
      "ui": {
        "decimalPlaces": 0,
        "control": "number",
        "currency": "MYR",
        "placeholder": "0",
        "dualColumn": true,
        "calculated": true,
        "readonly": true,
        "calculation": "ProfitAttributableToOwnersOfParent + ProfitAttributableToNonControllingInterests"
      }
    },
    {
      "qname": "ssmt:EarningsPerShareByNatureHeader",
      "label": "EARNINGS PER SHARE",
      "type": "SectionHeader",
      "ui": {
        "control": "header",
        "level": 2
      }
    },
    {
      "qname": "ifrs-full:BasicEarningsPerShareByNature",
      "label": "Basic earnings per share (sen)",
      "type": "PerShareItemType",
      "ui": {
        "control": "number",
        "currency": "MYR",
        "placeholder": "0.00",
        "dualColumn": true,
        "decimalPlaces": 2
      }
    },
    {
      "qname": "ifrs-full:DilutedEarningsPerShareByNature",
      "label": "Diluted earnings per share (sen)",
      "type": "PerShareItemType",
      "ui": {
        "control": "number",
        "currency": "MYR",
        "placeholder": "0.00",
        "dualColumn": true,
        "decimalPlaces": 2
      }
    }
  ],
  "roleId": "role-320000-mfrs",
  "roleUri": "http://xbrl.ssm.com.my/role/ssm/rol_ssmt-fs-mfrs_2022-12-31/ssmt-fs-mfrs_2022-12-31_role-320000",
  "taxonomy": "FS-MFRS"
}